module.exports = __webpack_public_path__ + "img/ask.89518274.png";